import { useQuery } from "@tanstack/react-query";
import Badge from "../Badge";
import { getProductStock } from "$services/Products.service";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  productId: string;
  companyId: string;
  isDisabled?: boolean;
};

export function ProductStockBadge({ productId, companyId, isDisabled }: Props) {
  const { data, isPending } = useQuery({
    queryKey: [CacheInvalidationAction.GET_PRODUCT_STOCK, productId, companyId],
    queryFn: () => getProductStock({ id: productId, company: companyId }),
    enabled: !!productId && !!companyId,
    staleTime: 1000 * 60,
  });

  const stock = data?.data?.[0]?.stock;

  if (isPending) {
    return null;
  }

  if (!stock || (stock.quantity ?? 0) <= 0) {
    return (
      <Badge color="red" isDisabled={isDisabled}>
        Rupture de stock
      </Badge>
    );
  }

  const available =
    (stock.quantityLastImport ?? 0) - (stock.edbReservedQuantity ?? 0);

  return <Badge isDisabled={isDisabled}>Dispo ({available})</Badge>;
}
